/**
 * A subtitle export (.srt / .vtt) shown as its words, not a blank file icon: the first lines of
 * the captions, and one click copies the whole text, like the Classic table's hover-to-copy.
 */
import React, { useEffect, useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { EXPORTS_PAPER } from "./libraryLookText";

const cache = new Map<string, string>();

/** The spoken lines of an SRT/VTT file: no numbers, no timecodes, no WEBVTT header. */
const spoken = (raw: string): string =>
  raw
    .split(/\r?\n/)
    .filter((l) => l.trim() && !/^\d+$/.test(l.trim()) && !l.includes("-->") && !/^WEBVTT/i.test(l.trim()))
    .join(" ");

const SubtitleText: React.FC<{ url: string; onCopy: (url: string) => void }> = ({ url, onCopy }) => {
  const [text, setText] = useState(() => cache.get(url) || "");
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (cache.has(url)) return undefined;
    let cancelled = false;
    fetch(url)
      .then((r) => (r.ok ? r.text() : ""))
      .then((raw) => { const t = spoken(raw); cache.set(url, t); if (!cancelled) setText(t); })
      .catch(() => { /* the card still offers Copy */ });
    return () => { cancelled = true; };
  }, [url]);

  return (
    <button
      type="button"
      className="xsub"
      title={EXPORTS_PAPER.copyHint}
      onClick={() => { onCopy(url); setCopied(true); setTimeout(() => setCopied(false), 1800); }}
    >
      <span className="xsub-tx">{text || "…"}</span>
      <span className={`xsub-hover${copied ? " done" : ""}`}>
        <ContentCopyIcon sx={{ fontSize: 22 }} />
        {copied ? EXPORTS_PAPER.copied : EXPORTS_PAPER.copyText}
      </span>
    </button>
  );
};

export default SubtitleText;
